import { MenuSection, MenuItem } from "@/types/components/navbar";

export const menuSections: MenuSection[] = [
  {
    title: "Account",
    items: [
      {
        title: "My Account",
        href: "/my-account?tab=account",
        icon: "/icons/user.svg",
        hasChevron: true,
      },
      {
        title: "My bookings",
        href: "/my-account?tab=bookings",
        icon: "/icons/luggage-03.svg",
        hasChevron: true,
      },
      {
        title: "Group Tours",
        href: "/group-tours",
        icon: "/icons/tent-tree.svg",
        hasChevron: true,
      },
    ],
  },
  {
    title: "Others",
    items: [
      { title: "About us", href: "/about-us" },
      { title: "Contact us", href: "/contact-us" },
      { title: "Reviews", href: "/reviews" },
      { title: "FAQs", href: "/faq" },
    ],
  },
];

export const socialLinks: MenuItem[] = [
  {
    title: "Facebook",
    href: "https://m.facebook.com/lykke.travel/",
    icon: "/icons/facebook.svg",
    isExternal: true,
  },
  {
    title: "Instagram",
    href: "https://www.instagram.com/travel.lykke/",
    icon: "/icons/instagram.svg",
    isExternal: true,
  },
  {
    title: "Youtube",
    href: "https://www.youtube.com/channel/UCIAwGvNuqlh5n1lFKXG2GaA",
    icon: "/icons/youtube.svg",
    isExternal: true,
  },
  {
    title: "Whatsapp",
    href: "https://api.whatsapp.com/send/?phone=918208025575",
    icon: "/icons/whatsapp.svg",
    isExternal: true,
  },
  // {
  //   title: "Explore",
  //   items: [
  //     {
  //       title: "Destinations",
  //       icon: "/icons/destinations-globe.svg",
  //       hasChevron: true,
  //       onClick: () => setCurrentView("destinations"),
  //     },
  //     {
  //       title: "Packages",
  //       icon: "/icons/packages-ticket.svg",
  //       href: "/packages",
  //     },
  //   ],
  // },
];

export const footerSocialLinks = [
  {
    title: "Facebook",
    href: "https://m.facebook.com/lykke.travel/",
    icon: "/icons/facebook.svg",
  },
  {
    title: "Instagram",
    href: "https://www.instagram.com/travel.lykke/",
    icon: "/icons/instagram.svg",
  },

  {
    title: "Youtube",
    href: "https://www.youtube.com/channel/UCIAwGvNuqlh5n1lFKXG2GaA",
    icon: "/icons/youtube.svg",
  },
  {
    title: "Whatsapp",
    href: "https://api.whatsapp.com/send/?phone=918208025575",
    icon: "/icons/whatsapp.svg",
  },
];

export const footerSections = [
  {
    title: "Quick Links",
    links: [
      { label: "Home", url: "/" },
      { label: "Packages", url: "/packages" },
      { label: "About Us", url: "/about-us" },
      { label: "Contact Us", url: "/contact-us" },
      { label: "Reviews", url: "/reviews" },
      { label: "Privacy Policy", url: "/privacy-policy" },
      { label: "Terms & Conditions", url: "/terms-and-conditions" },
      { label: "FAQs", url: "/faq" },
    ],
  },
  {
    title: "Must Visit",
    links: [
      { label: "Egypt", url: "/packages/destination/egypt" },
      { label: "Georgia", url: "/packages/destination/georgia" },
      { label: "Kenya", url: "/packages/destination/kenya" },
      { label: "Turkey", url: "/packages/destination/turkey" },
      { label: "Azerbaijan", url: "/packages/destination/azerbaijan" },
      { label: "Philippines", url: "/packages/destination/philippines" },
      { label: "Kazakhstan", url: "/packages/destination/kazakhstan" },
      { label: "Tanzania", url: "/packages/destination/tanzania" },
    ],
  },
  {
    title: "Popular",
    links: [
      { label: "Thailand", url: "/packages/destination/thailand" },
      { label: "Singapore", url: "/packages/destination/singapore" },
      { label: "Malaysia", url: "/packages/destination/malaysia" },
      { label: "Maldives", url: "/packages/destination/maldives" },
      { label: "Mauritius", url: "/packages/destination/mauritius" },
      { label: "Vietnam", url: "/packages/destination/vietnam" },
      { label: "Bhutan", url: "/packages/destination/bhutan" },
      { label: "Jordan", url: "/packages/destination/jordan" },
      { label: "Sri Lanka", url: "/packages/destination/srilanka" },
      { label: "Greece", url: "/packages/destination/greece" },
    ],
  },
  {
    title: "Honeymoon Packages",
    links: [
      {
        label: "Maldives Sea Adventure",
        url: "/package/maldives-sea-adventure",
      },
      { label: "Sacred Sands Bali", url: "/package/sacred-sands-bali" },
      {
        label: "Greek Signature Escape",
        url: "/package/greek-signature-escape",
      },
      { label: "Moonlit Mauritius", url: "/package/moonlit-mauritius" },
      {
        label: "Classic Thailand Highlights",
        url: "/package/classic-thailand-highlights",
      },
      { label: "Singapore Uncovered", url: "/package/singapore-uncovered" },
      { label: "Mystic Malaysia", url: "/package/mystic-malaysia" },
      {
        label: "Timeless Vietnam Voyage",
        url: "/package/timeless-vietnam-voyage",
      },
      {
        label: "Majestic Sights of Turkey",
        url: "/package/majestic-sights-of-turkey",
      },
      { label: "Georgian Trails", url: "/package/georgian-trails" },
    ],
  },
];

export const footerLinks = [
  { label: "Home", url: "/" },
  { label: "Packages", url: "/packages" },
  { label: "About Us", url: "/about-us" },
  { label: "Contact Us", url: "/contact-us" },
  { label: "Testimonials", url: "/testimonials" },
  { label: "Privacy Policy", url: "/privacy-policy" },
  { label: "Terms & Conditions", url: "/terms-and-conditions" },
  { label: "Popular", url: "/packages" },
  { label: "Themes", url: "/packages" },
  { label: "Must Visit", url: "/packages" },
];

export const contactUsData = {
  title: "Contact Us",
  description:
    "Reach out via email, give us a call, or fill out the form to share your needs with us.",
  contactSource: [
    {
      icon: "/icons/mail-02.svg",
      title: "Email Support",
      description: "holidays@lykke.travel",
      link: "mailto:holidays@lykke.travel",
    },
    {
      icon: "/icons/phone.svg",
      title: "Call us Directly",
      description: "+91 80474 93335",
      link: "tel:+918047493335",
    },
    {
      icon: "/icons/whatsapp-02.svg",
      title: "WhatsApp your query",
      description: "+91 82080 25575",
      link: "https://wa.me/918208025575",
    },
  ],
  support: [
    {
      icon: "/icons/users-02.svg",
      title: "Customer Support",
      description:
        "Our support team is available around the clock to address any concerns or queries you may have.",
    },
    {
      icon: "/icons/message-smile-square.svg",
      title: "Feedback and Suggestions",
      description:
        "We appreciate your feedback and are committed to improving. Your input is vital for our future.",
    },
  ],
};

export const contactUsLocationDetail = {
  title: "Our Location",
  subTitle: "Visit our office locations or contact us today",
  offices: [
    {
      title: "Pune Office",
      address:
        "Office no. 303, Niche Facade building, \n New airport road, Viman Nagar",
      city: "Pune - 411014",
      online: false,
    },
    {
      title: "Jaipur Office",
      address:
        "A7, JDA Staff Colony Block B, Haldighati Marg, Pratap Nagar, Jaipur 302033",
      city: "Jaipur - 302033",
      online: false,
    },
    {
      title: "Bangalore Office",
      address: "204, 2nd Floor, Soul City, Gunjur, \n Near IBO Varthur",
      city: "Bangalore - 560087",
      online: false,
    },
  ],
};

export const privacyPolicyData = {
  title: "Privacy Policy",
  introduction:
    "This website (www.lykke.travel) is owned and operated by Travel LYKKE Private Limited (hereinafter referred to as “Travel LYKKE”). At Travel LYKKE, we are committed to ensuring that your private information remains private. We have created this privacy policy so that you can understand our continuing commitment to ensuring that your information remains secure and private. These guidelines have been developed with the recognition that Internet technologies and legislation are rapidly evolving, and that underlying business models are still not established. Accordingly, guidelines are subject to change. Any such changes will be posted on this page.",
  sections: [
    {
      id: 1,
      title: "What information does Travel LYKKE collect from me?",
      content:
        "We collect information in several ways. For the purpose of serving you, we may ask you for your name, e-mail address, phone number, address and other relevant information needed to make travel plans or any other services offered by us. Most sections of our website can be viewed without submitting any personal information by the user.",
    },
    {
      id: 2,
      title: "How do I delete my data from Travel LYKKE website?",
      content:
        "Just send us an email at hello@lykke.travel and we'll delete all your data from all our systems, including this website within 7 days.",
    },
    {
      id: 3,
      title: "How does Travel LYKKE use my information?",
      content:
        "Travel LYKKE collects information from you to enhance your visit and assist you with travel bookings. We are able to provide the requested information promptly and accurately, which makes it easier and more rewarding for you to use our services.",
    },
    {
      id: 4,
      title: "With whom does Travel LYKKE share my information?",
      content:
        "At Travel LYKKE, when you provide your personal information including name, address, phone number and e-mail address, this information is kept secured and is not divulged to any outside company for use in marketing or solicitation. Travel LYKKE will not sell or rent your personally identifiable information at any time to anyone. It is to be noted that Travel LYKKE works with various partner companies in providing the required services to you. For this purpose, we share required personal information with our partner companies.",
    },
    {
      id: 5,
      title: "What are the security policies of linked third-party sites?",
      content:
        "This web site may contain links to other web sites. Please note that if you click on one of these links, you are moving to a third-party web site. We encourage you to read the privacy statements of these linked sites as their privacy policy may differ from ours. This privacy statement applies solely to information collected by this web site.",
    },
    {
      id: 6,
      title: "How can you access or update your information?",
      content:
        "You can correct or update the information we collect at any time by contacting us. To protect your privacy and security, we will take reasonable steps to verify your identity before granting access or making corrections to your information.",
    },
    {
      id: 7,
      title: "What else should I know about internet security?",
      content:
        "Unfortunately, no data transmission over the Internet can be guaranteed to be 100% secure. We strive to protect your personal information. Travel LYKKE, however, cannot ensure or warrant the security of any information you transmit to us, and any information you submit online is done voluntarily and at your own risk. Once we receive your transmission, we make our best effort to ensure its security on our systems.",
    },
    {
      id: 8,
      title: "What is a cookie?",
      content:
        "A cookie is a small data file that is stored locally on your computer that allows specific information to be saved and retrieved when the site requires it.",
    },
    {
      id: 9,
      title: "What is Travel LYKKE's cookie policy?",
      content:
        "In order to provide you with the most efficient service, our website may employ “cookie technology”. Cookies are small pieces of information that are stored by your browser on your computer’s hard drive. Cookies enable sites to recognize repeat visitors and allow a site to track usage behaviour and compile aggregate data that assists in content and system enhancements. Cookies are not programs that come onto a user’s system and change or damage files. If a user does not want information collected through the use of cookies, there is a simple procedure in your browser to warn you before accepting cookies or to refuse cookies altogether. However, users should note that cookies might be necessary to provide the user with certain customized features available on our site and other websites as well.",
    },
    {
      id: 10,
      title: "How do I contact Travel LYKKE?",
      content:
        "Should you have other questions or concerns about this privacy policy or your electronic records maintained by Travel LYKKE, please contact us through our Contact page.",
    },
  ],
};

export const termsAndConditionsData = {
  title: "Terms & Conditions",
  introduction:
    'This website (www.lykke.travel) is owned and operated by Travel LYKKE Private Limited. Access to and use of the services of Travel LYKKE Private Limited (hereinafter referred to as "Travel LYKKE" or "our" or "us" or "we") and our website is subject to acceptance of these terms and conditions. By accessing, using or obtaining any content, products, or services through us, you, the purchaser and/or traveler (hereinafter referred to as "Customer" or "passenger" or "you/your") agree to be bound by these terms. PLEASE READ THE TERMS BEFORE USING THIS WEBSITE. These terms and conditions govern the relationship between Travel LYKKE and you, the Customer. IF THERE IS ANY PART OF THESE TERMS AND CONDITIONS YOU DO NOT AGREE WITH, PLEASE DO NOT USE THIS WEBSITE OR Travel LYKKE\'s SERVICES.',
  sections: [
    {
      id: 1,
      title: "Responsibility",
      content:
        "The Products are sold by us as agents for AIRLINE AND WHOLESALE COMPANIES and other principals providing, inter alia, accommodation and transportation services. All tickets, coupons, exchange orders, vouchers and receipts are issued subject to the appropriate tariffs and terms and conditions of sale of our principals and these conditions. It is therefore important to note that all bookings made by us are subject to the terms and conditions imposed by airlines, coach operators, hoteliers and others providing services including, but not limited to, shipping, rail, car hire, ferry, tour and restaurant operators whose services are utilised by us, some of which limit or exclude liability in respect of insolvency, non-operation, death, personal injury, delay and loss or damage to baggage.",
    },
    {
      id: 2,
      title: "Liability",
      content:
        "Travel LYKKE accepts no liability for any loss or damage occasioned by the negligence of such principals and reserves the right to cancel or modify itineraries or bookings where circumstances require. Travel LYKKE cannot accept any liability for the acts, omissions or default, whether negligent or otherwise, of airlines, car rental operators, ferry companies, hoteliers, tour operators or other persons providing services in connection with your tour, over whom Travel LYKKE has no direct or exclusive control. Your acceptance of any tickets, coupons, exchange orders, vouchers and receipts will be deemed acceptance of the above conditions and of any alterations made to your tour. Travel LYKKE reserves the right to decline acceptance of any individual on any tour.",
    },
    {
      id: 3,
      title: "Rates and Price Variations",
      content:
        "Travel LYKKE reserves the right to vary the rates in the event of extremely adverse fluctuations in exchange rates or change in government taxes or reasonable price rises forced by the wholesale partner companies.",
    },
    {
      id: 4,
      title: "Correctness of passenger information",
      content:
        "Please ensure that the spelling of all names, date of birth and other information provided by you at the time of booking is correct and match exactly as shown on your passport(s). It is your responsibility to advise us of the correct information at the time of booking, as you will incur substantial costs to amend details at a later stage if the information you supplied was incorrect.",
    },
    {
      id: 5,
      title: "Passport and Visas",
      content:
        "It is very important that you read the following information carefully and contact our office if you require any assistance in any area. All individuals booking foreign tours with us must be in possession of a valid passport which must have at least two blank pages & 6 months' validity from your intended date of return journey. Several countries require your passport to have 1 year's validity from your intended date of return journey. If your passport is due to expire within next twelve months, then under normal circumstances we advise you to obtain a new passport. At Travel LYKKE, we provide services for facilitating visa application process for you. It is to be noted that issuance of visa is solely at the discretion of respective embassy. The whole process is completely outside the control of our visa processing partners or ours. Customer will have to assume complete responsibility for any delays/cancellations arising due to delayed/rejected visa applications. Even after issuance of visa, entry to any country is at the discretion of relevant immigration authorities on arrival. Regardless of whether you possess a valid visa, entry into a particular country can still depend solely on the discretion of the Immigration Official on arrival in that country. Under those circumstances Travel LYKKE cannot be held responsible for a country refusing entry to any individual irrespective of that country's normal entry procedures. If you are in doubt it is your responsibility to contact the relevant government agency or consulate prior to your departure.",
    },
    {
      id: 6,
      title: "Payments",
      content:
        "Minimum 50% payment is required to secure your booking. No liability will be accepted by us until payment is actually received by us. Any price variations due to delay in payment will have to be borne by the customer. Any binding contract will only exist between you and Travel LYKKE when final payment has been made and all tickets, coupons, exchange orders, vouchers and receipts have been issued to you by us.",
    },
    {
      id: 7,
      title: "Cancellation of Booking",
      content:
        "Please refer to our cancellation policy. In case of any doubt, please do not hesitate to contact us.",
    },
    {
      id: 8,
      title: "Flight Timings, Departure Points, Flight Numbers",
      content:
        "The timings shown on your ticket are subject to re-confirmation with the airline company. Please contact the applicable Airline 72 hours before departure. Travel LYKKE cannot accept responsibility for amended flight timings or numbers.",
    },
    {
      id: 9,
      title: "Multiple Tickets and Connections",
      content:
        "If you have purchased multiple tickets which mean you are transiting or connecting from one carrier to another or the same carrier, we cannot accept responsibility for any future schedule changes that may affect your connecting times. Also, we cannot accept responsibility for any additional costs incurred in changing your flights to accommodate possible future amended schedules. Please note that when booked on multiple airlines (and sometimes even on the same airline) you may need to check in your baggage for each flight separately at the transit point.",
    },
    {
      id: 10,
      title: "Hotels",
      content:
        "Please note that hotels sometimes may refuse to honour the reservations due to overbooking. In such cases, we'll arrange alternative accommodation in a similar or higher category hotel in consultation with the customer, or offer a refund for that hotel if the customer wishes so. You should also be aware that hotel grades and hotel standards do vary between countries.",
    },
    {
      id: 11,
      title: "Refunds for Unused Services",
      content:
        "No refunds will be made for unused services where a client terminates the service after it has commenced regardless of reason.",
    },
    {
      id: 12,
      title: "Privacy Policy",
      content:
        "Please refer to our privacy policy. In case of any doubt, please do not hesitate to contact us.",
    },
    {
      id: 13,
      title: "Limitation of Liability",
      content:
        "Without limitation, Passenger(s) assume the risk of, and agree that Travel LYKKE or its partners are not liable for any damages arising from or related to any act of God or public enemies, arrest, restraints of any government or rulers of people, piracy, war, revolution, extortion, terrorist activity, threatened or actual rebellion, political upheaval, civil unrest, riots, fire, lockouts, explosion, collision, weather conditions, dangers incident to the sea, mechanical or construction failures or difficulties, diseases, local laws, abnormal conditions or developments, closure of airports/seaports/hotels/train stations, carrier or supplier logistical problems, computer problems stranding, food or water poisoning, illness, grounding, perils of the sea, rivers, canals, locks or other waters, perils of navigation of any kind, theft, accident to or from machinery, boilers, or latent defects even though existing at commencement of the trip, desertion or revolt of crew, or lost/damaged/delayed luggage. It is your sole responsibility to abide by rules and regulations, laws of the land, general code of conduct in any place you are in. Travel LYKKE or its partners will not be responsible for any damages or inconveniences arising out of breach of laws or code of conduct by you.",
    },
    {
      id: 14,
      title: "Severability",
      content:
        "If any provision of this agreement shall be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from this agreement and shall not affect the validity and enforceability of any remaining provisions.",
    },
    {
      id: 15,
      title: "Headings",
      content:
        "Headings are for reference purposes only and do not limit the scope or extent of such section.",
    },
    {
      id: 16,
      title: "Copyrights",
      content:
        "This website contains visual, audio and video content protected by copyrights by Travel LYKKE or our partners. No material from this website may be modified, copied, reproduced, republished, downloaded, posted, displayed, transmitted, performed, licensed, used to make a derivative work, transferred, sold or distributed in any way, without our prior written consent. You may not frame or mirror any material on this website on any other server or other location. Unauthorized use of any such material on any other website or computer environment or elsewhere is prohibited",
    },
    {
      id: 17,
      title: "Right to refuse service",
      content:
        "Travel LYKKE reserves the right to refuse service to any customer, if it believes that customer’s actions are in breach of these terms and conditions, or government rules and regulations, or if the customer has wilfully provided invalid information or misrepresented any facts. Any damages arising out of such refusal of service will be borne by customer.",
    },
    {
      id: 18,
      title: "Jurisdiction",
      content:
        "Travel LYKKE expressly disclaims any implied warranties imputed by the laws of any jurisdiction other than those where it is operating its offices.",
    },
    {
      id: 19,
      title: "Modification of these Terms and Conditions",
      content:
        "We reserve the right, in our sole discretion, to change these Terms at any time. Updated versions of the Terms will be posted here on this website and are effective immediately on posting. Please check frequently, especially before you use this website, to see if these Terms changed. Use of the website after any changes to the Terms constitutes your consent to the changes.",
    },
  ],
};

// export const savedPackages = [
//   {
//     title: "Georgia Beyond the Ordinary",
//     uid: "BZVEMBA98Z",
//     slug: "georgia-beyond-the-ordinary",
//     images: [
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/8/6pc0jxlunz.jpg",
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/9/f9ggv4ptnv.jpg",
//     ],
//     duration: {
//       number_of_day: 6,
//       number_of_night: 0,
//     },
//     price: {
//       value: "52160.00",
//       currency: "INR",
//     },
//     cities: ["Batumi", "Tbilisi"],
//     key_highlights: [
//       "Holy Trinity Cathedral",
//       "Martvili Canyon",
//       "Prometheus Cave",
//       "Batumi Botanical Garden",
//       "Kakheti wine region experience",
//     ],
//   },
//   {
//     title: "Georgia Heritage and Wine Escape",
//     uid: "WZGQT5ZZSN",
//     slug: "georgia-heritage-and-wine-escape",
//     images: [
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/10/8bgab2mk4j.jpg",
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/11/dtt4dyzk8t.jpg",
//     ],
//     duration: {
//       number_of_day: 6,
//       number_of_night: 0,
//     },
//     price: {
//       value: "66090.00",
//       currency: "INR",
//     },
//     cities: ["Tbilisi", "Kazbegi"],
//     key_highlights: [
//       "Holy Trinity Cathedral",
//       "Ananuri Fortress",
//       "Gveleti Waterfall",
//       "Kakheti wine region experience",
//     ],
//   },
//   {
//     title: "Georgia's Cultural and Scenic Gems",
//     uid: "CXKLGN9RME",
//     slug: "georgias-cultural-and-scenic-gems",
//     images: [
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/1/z74xs9qrqx.jpg",
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/2/3nj4gmyza0.jpg",
//     ],
//     duration: {
//       number_of_day: 4,
//       number_of_night: 0,
//     },
//     price: {
//       value: "36790.00",
//       currency: "INR",
//     },
//     cities: ["Tbilisi"],
//     key_highlights: [
//       "Holy Trinity Cathedral, Ananuri Fortress",
//       "Abanotubani Sulphur Bath District",
//       "Cable car ride to Mtatsminda Park",
//       "Kakheti wine region experience",
//     ],
//   },
// ];

// export const quotation = [
//   {
//     id: 1,
//     isExpired: false,
//     date: "2025-01-01",
//     title: "Discover Thailand – A City of Lights, Culture & Wonder",
//     price: {
//       value: "52160.00",
//       currency: "INR",
//     },
//     cities: [
//       {
//         name: "Batumi",
//         id: 4917,
//         duration: 2,
//       },
//       {
//         name: "Kutaisi",
//         id: 37287,
//         duration: 1,
//       },
//       {
//         name: "Phuket",
//         id: 161098,
//         duration: 1,
//       },
//     ],
//     travellers: 14,
//     image:
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/1/z74xs9qrqx.jpg",
//     travel_end_date: "20th June",
//     travel_start_date: "12th June",
//   },
//   {
//     id: 2,
//     isExpired: true,
//     date: "2025-01-01",
//     title: "Georgia Beyond the Ordinary",
//     price: {
//       value: "52160.00",
//       currency: "INR",
//     },
//     cities: [
//       {
//         name: "Bakuriani",
//         id: 161098,
//         duration: 1,
//       },
//       {
//         name: "Phuket",
//         id: 161098,
//         duration: 1,
//       },
//     ],
//     travellers: 14,
//     image:
//       "https://dev-lykke-public-assets.s3.amazonaws.com/media/images/collection/1/z74xs9qrqx.jpg",
//     travel_end_date: "20th June",
//     travel_start_date: "12th June",
//   },
// ];

export const UTM_KEYS = [
  "utm_campaign",
  "utm_source",
  "utm_medium",
  "fbclid",
  "utm_term",
  "utm_content",
  "referrer_code",
  "param1",
  "param2",
  "gclid",
  "twclid",
  "aclk",
  "msclkid",
  "destination",
];

export const billingDetailsFormFields = {
  title: "Billing Address",
  formFields: [
    {
      name: "address_line_1",
      label: "Address Line 1",
      type: "text",
      placeholder: "Address line 1",
      errorMessage: "Please enter an address",
    },
    {
      name: "address_line_2",
      label: "Address Line 2",
      type: "text",
      placeholder: "Address line 2",
      errorMessage: "Please enter an address",
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "City",
      errorMessage: "Please enter a city",
    },
    {
      name: "state",
      label: "State",
      type: "text",
      placeholder: "State",
      errorMessage: "Please enter a state",
    },
    {
      name: "zip_code",
      label: "Zip Code",
      type: "number",
      placeholder: "Zip Code",
      errorMessage: "Please enter a zip code",
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder: "Country",
      errorMessage: "Please enter a country",
    },
  ],
};

export const PAYMENT_STATUS = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  INITIATED: "INITIATED",
  EXPIRED: "EXPIRED",
} as const;

export const LOGIN_LEAD_TRIGGER_SOURCES = {
  LOGIN_BUTTON: "login_button",
  TALK_TO_AN_EXPERT: "talk_to_an_expert",
  CUSTOMIZE_THIS_TRIP: "customize_this_trip",
  PLAN_WITH_AI: "plan_with_ai",
  HOMEPAGE_SCROLL: "homepage_scroll",
  HOMEPAGE_BANNER: "homepage_banner",
  DESTINATION_BANNER: "destination_banner",
  PACKAGE_BANNER: "package_banner",
  CONTACT_US: "contact_us",
};

export function getBannerLeadCallout(pathname: string) {
  if (pathname.includes("/packages/destination/")) {
    return LOGIN_LEAD_TRIGGER_SOURCES.DESTINATION_BANNER;
  }
  if (pathname.startsWith("/packages")) {
    return LOGIN_LEAD_TRIGGER_SOURCES.PACKAGE_BANNER;
  }
  if (pathname === "/") {
    return LOGIN_LEAD_TRIGGER_SOURCES.HOMEPAGE_BANNER;
  }
  return LOGIN_LEAD_TRIGGER_SOURCES.DESTINATION_BANNER;
}

export const FORM_TYPES = {
  LOGIN_FORM: "login_form",
  LEAD_WALKTHROUGH_FORM: "lead_walkthrough_form",
};

export const REFERRING_PROPERTY_TYPES = {
  GROUP_TOUR: "group_tour",
  CUSTOMIZABLE_PACKAGE: "customizable_package",
  ACTIVITY: "activity",
};

export const PAGE_NAME = {};

export const GOOGLE_RATING = 4.6;
export const NUMBER_OF_TRAVELLERS = 8000;
export const NUMBER_OF_REVIEWS = 2500;
export const NUMBER_OF_TRIPS_CRAFTED = 2500;
export const NUMBER_OF_DESTINATIONS = 30;

export const GENERIC_TESTIMONIAL_THUMBNAIL_URL = "/generic/testimonial.webp";
